import React, { lazy, memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, useLocation } from 'react-router-dom';
import colors from './colors.json';
import AuthLayout from './components/AuthLayout';
import AuthRoute from './components/AuthRoute';
import { registerBuilder } from './components/Builder';
import FormBuilder from './components/Builder/FormBuilder';
import PageBuilder from './components/Builder/PageBuilder';
import ErrorDisplay from './components/ErrorDisplay';
import Loader from './components/Loader';
import PrivateRoute from './components/PrivateRoute';
import { withGlobalLoader, withSuspense } from './helpers/hocs';
import routes from './routes';
import LogoutView from './views/Auth/LogoutView';
import { parseQueryString } from './helpers/utils';
import uiActions from './store/modules/ui/actions';

const AuthLayoutLoader = () => (
  <AuthLayout>
    <Loader color={colors['white']} />
  </AuthLayout>
);

const ForgotPasswordView = withSuspense(
  lazy(() => import('./views/Auth/ForgotPasswordView')),
  <AuthLayoutLoader />,
);
const LoginView = withSuspense(
  lazy(() => import('./views/Auth/LoginView')),
  <AuthLayoutLoader />,
);
const RegisterView = withSuspense(
  lazy(() => import('./views/Auth/RegisterView')),
  <AuthLayoutLoader />,
);
const ResetPasswordView = withSuspense(
  lazy(() => import('./views/Auth/ResetPasswordView')),
  <AuthLayoutLoader />,
);
const DashboardView = withSuspense(lazy(() => import('./views/Dashboard')));

registerBuilder('Form', FormBuilder);
registerBuilder('Page', PageBuilder);

Loader.Error = ErrorDisplay;

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const [, state = {}] = parseQueryString(location.search);
    if (state.ref) dispatch(uiActions.setRef(state.ref));
  }, [dispatch, location.search]);

  useEffect(() => {
    // const setId = () => {
    //   const params = new URLSearchParams(location.search);
    //   const id = params.get("id");

    //   if (id) {
    //     localStorage.setItem("sessionId", id);
    //   }
    // };
    // setId();


    // const currentTime = Date.now();
    // const isValid = savedId >= currentTime;

    // if (!isValid) {
    // }
    window.location.href = "https://mobile.piggyvest.com";
  }, []);

  return (
    <Switch>
      <AuthRoute path={routes.Register.pathname}>
        <RegisterView />
      </AuthRoute>
      <AuthRoute path={routes.Login.pathname}>
        <LoginView />
      </AuthRoute>
      <AuthRoute path={routes.ForgotPassword.pathname}>
        <ForgotPasswordView />
      </AuthRoute>
      <AuthRoute path={routes.ResetPassword.pathname}>
        <ResetPasswordView />
      </AuthRoute>
      <Route path={routes.LogOut.pathname}>
        <LogoutView />
      </Route>
      <PrivateRoute path={routes.Home.pathname}>
        <DashboardView />
      </PrivateRoute>
    </Switch>
  );
};

export default withGlobalLoader(memo(App));
